import type { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { LaunchStatus } from '../../types/hypothesis';
import { LAUNCH_STATUS_OPTIONS } from '../../types/hypothesis';
import type { FilterSize } from './filterSize';
import { DEFAULT_FILTER_SIZE } from './filterSize';

interface StatusFilterSelectProps {
  value: LaunchStatus | null;
  onChange: (val: LaunchStatus | null) => void;
  minWidth?: number;
  size?: FilterSize;
  allLabel?: string;
}

const StatusFilterSelect: FC<StatusFilterSelectProps> = ({
  value,
  onChange,
  minWidth = 130,
  size = DEFAULT_FILTER_SIZE,
  allLabel = 'All',
}) => {
  return (
    <FormControl size={size} sx={{ minWidth }}>
      <InputLabel>Status</InputLabel>
      <Select
        label="Status"
        size={size}
        value={value ?? ''}
        onChange={(e) => {
          const next = e.target.value as LaunchStatus | '';
          onChange(next === '' ? null : next);
        }}
      >
        <MenuItem value="">{allLabel}</MenuItem>
        {LAUNCH_STATUS_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusFilterSelect;
